<template>
  <span>
    <h2 class="title is-uppercase is-left">{{ $t('projectPage.ask') }}:</h2>
    <input class="question input" type="string" placeholder="What will you ask today?" value="poll.question"
           v-model="poll.question" qa="poll-question-input">
    <span v-if="type !== 'textField'"
          :class="{'form': type !== poll}">
      <div v-if="type !== 'poll' || type !== 'textfield'"
           :class="{'form_columns' : type !== 'poll' || type !== 'textfield'}">
        <h2 class="title is-uppercase is-left">Answer {{ $t('projectPage.options') }}:</h2>
          <div v-for="(pollOption, index) in pollOptions" :key="index" class="option">
            <button v-if="type !== 'poll'"
                    class="delete is-primary"
                    @click="deletePollOption(index)"
                    :qa="'delete-option-'+(index+1)+'-button'" />
            <input class="input input_form" type="string" :placeholder="'Option ' + (index + 1)"
                   value=""
                   v-model="pollOption.option" :qa="'option-'+(index+1)">
            <button v-if="type === 'poll'"
                    class="delete is-primary"
                    @click="deletePollOption(index)"
                    :qa="'delete-option-'+(index+1)+'-button'" />
          </div>
          <button v-if="type === 'poll'"
                class="button is-outlined is-size-7 is-uppercase is-primary"
                :class="{'button_form' : (type === 'singleSelect' || type === 'multiSelect')}"
                @click="addPollOption"
                qa="add-option-button">{{ $t('projectPage.addOption') }} &nbsp;<i class="fal fa-plus" />
          </button>
      </div>
      <div v-if="type !== 'poll'"
           :class="{'form_columns' : type !== 'poll' || type !== 'textfield'}">
        <span style="display: flex; flex-direction: row; justify-content: space-around">
          <span>
            <!-- Update the tags -->
            <h2 class="title is-uppercase is-left">{{ $t('projectPage.tags') }}:</h2>
            <div v-for="(pollOption, index) in pollOptions" :key="index" class="option">
              <input class="input form_input-tag"
                     type="string"
                     placeholder="Single tag input"
                     v-model="pollOption.tag" :qa="'option-'+(index+1)">
            </div>
          </span>
          <span>
            <!-- Update the score -->
            <h2 class="title is-uppercase is-left">{{ $t('projectPage.score') }}:</h2>
            <div v-for="(pollOption, index) in pollOptions" :key="index" class="option">
              <input class="input form_input-score"
                     type="number"
                     :placeholder="(index + 1)"
                     v-model.number="pollOption.score" :qa="'option-'+(index+1)">
            </div>
          </span>
        </span>
      </div>
      <button v-if="type !== 'poll'"
          class="button is-outlined is-size-7 is-uppercase is-primary button_form"
          @click="addPollOption"
          qa="add-option-button">{{ $t('projectPage.addOption') }} &nbsp;<i class="fal fa-plus" />
      </button>
    </span>
  </span>
</template>
<script>
export default {
  data: function () {
    return {
      scoreTesting: 0
    }
  },
  props: {
    judgeScoreLimit: {
      type: Number,
      default: 10
    },
    type: {
      type: String,
      required: true
    },
    poll: {
      type: Object,
      required: true
    },
    pollOptions: {
      type: Array,
      required: true
    },
    deletePollOption: {
      type: Function,
      required: true
    },
    addPollOption: {
      type: Function,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.input {
  &_form {
    max-width: 230px;
    @include mobile {
      max-width: 320px;
    }
  }
}

.form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0;
  @include mobile {
    grid-template-columns: 1fr;
  }
  &_input {
    @include mobile {
      width: 100%;
    }
    &-score {
      max-width: 60px;
      text-align: center;
    }
    &-tag {
      max-width: 180px;
      margin-right: 1rem;
      @include mobile {
        margin-right: 0;
        max-width: 250px;
      }
    }
  }
  &_columns {
    grid-row: 1;
    @include mobile {
      grid-row: unset;
      grid-column: 1;
    }
  }
  &_selection {
    display: flex;
    flex-direction: row;
    margin-right: 10px;
    color: white;
    background: linear-gradient(to right, darken($primary, 20%), $primary);
    &_item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 0px 5px 0px 5px;
      background: linear-gradient(to bottom, #fff, #fff 40%, rgba(255,0,0,0) 40%, rgba(255,0,0,0) 80%, rgba(255,255,255,0));
    }
    &_icon {
      color: transparent;
      &-active {
        color: $primary;
      }
    }
  }
}

.poll {
  .title {
    font-size: .9rem;
    margin: 1rem 0;
  }

  .option {
    margin-top: 1rem;
  }

  .option:last-of-type {
    margin: 1rem 0;
  }

  .button {
    border-radius: 1px;
    &_form {
      max-width: 230px;
      width: 115px;
      @include mobile{
        margin-left: 10px;
      }
    }
  }

  .delete {
    background-color: $primary;
    opacity: .7;
    margin-top: .5rem;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
